<!--
    ShowWelcome.vue
    Component to show the text of a welcome message.
    by Guy E. White <guw968@g.harvard.edu>
-->
<template>
    <div id='welcome'>
        <h2>What is this thing?</h2>
        <p>This tool can help you get started in selecting the right statistical test for your dissertation or thesis. Time and time again, candidates some to me seeking help with their statistics. While I’m not a statistics expert by any means, I built this tool to help you get your start in doing the crazy, difficult work required to undertake quantitative research and understand statistics. This tool is only a first step in your journey: Let it be the first step toward you learning more using the great work of other out there in the world. This tool is a work in progress.
        </p>
    </div>
</template>

<script>
export default {
    name: '',
    data: function() {
        return {};
    }
};
</script>

<style scoped>
</style>
